export default {
  Withdraw: 'WithdrawModal',
  Offer: 'OfferModal',
  LimitOrder: 'LimitOrder',
  PrivateKeys: 'PrivateKeysModal',
  ReceiveModal: 'ReceiveModal',
  DownloadModal: 'DownloadModal',
  Confirm: 'Confirm',
  DeclineOrdersModal: 'DeclineOrdersModal',
  IncompletedSwaps: 'IncompletedSwaps',
  ConfirmBeginSwap: 'ConfirmBeginSwap',
  MultisignJoinLink: 'MultisignJoinLink',
  WithdrawMultisigUser: 'WithdrawModalMultisigUser',
  CurrencyAction: 'CurrencyAction',
  InvoiceModal: 'InvoiceModal',
  InvoiceLinkModal: 'InvoiceLinkModal',
  AlertModal: 'AlertModal',
  AddCustomToken: 'AddCustomToken',
  BtcMultisignSwitch: 'BtcMultisignSwitch',
  Share: 'ShareModal',
  BtcMultisignConfirmTx: 'BtcMultisignConfirmTx',
  SaveMnemonicModal: 'SaveMnemonicModal',
  RestoryMnemonicWallet: 'RestoryMnemonicWallet',
  HowToWithdrawModal: 'HowToWithdrawModal',
  InfoInvoice: 'InfoInvoice',
  PrivateKeysModal: 'PrivateKeysModal',
  RegisterPINProtected: 'RegisterPINProtected',
  WithdrawBtcPin: 'WithdrawBtcPin',
  WalletAddressModal: 'WalletAddressModal',
  AlertWindow: 'AlertWindow',
  WithdrawBtcMultisig: 'WithdrawBtcMultisig',
  ConnectWalletModal: 'ConnectWalletModal',
  WalletConnectAccount: 'WalletConnectAccount',
  ShamirsSecretRestory: 'ShamirsSecretRestory',
  ShamirsSecretSave: 'ShamirsSecretSave',
  RestoreWalletSelectMethod: 'RestoreWalletSelectMethod',
  SaveWalletSelectMethod: 'SaveWalletSelectMethod',
}
